<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>{{schemaField.name}}</template>
        <template v-slot:content>
            <v-layout column align-center justify-center>
                <span class = 'py-3 text-center subheading font-weight-regular'>Удалить выбранное поле из схемы отчета?</span>
            </v-layout>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteSchemaField'>Удалить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'DeleteSchemaField',
        props: ['visibility', 'schemaField'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visible: this.visibility,
                indicator: false,
                action: false
            }
        },
        methods: {
            deleteSchemaField() {
                this.indicator = true;
                let project = this.$store.state.currentProject
				let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
		        this.$http.patch(this.$store.getters.endpoint + '/db/project/' + project.project_id + '/schema', {
                        'login': this.$store.getters.userLogin,
                        field_id: this.schemaField.field_id
				    } , {
				        headers: {...this.$store.state.restrictedHeaders,...requestHeaders
				    }
			    }).then( (r) => {
                    this.indicator = false
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'delete',
                            target: 'project_schemafield'
                        },
                        once: false
                    })
                    this.action = true
                    this.visible = false
			    });
			},
        },
        watch: {
            visibility(value) {
                this.visible = value
            },
            visible(value) {
                if (!value) {
                    this.$root.$emit('CRUDSchemaVisibility', {visibility: value, update: this.action, type: 'delete'})
                }
            }
        }
    }
</script>